import { IntegrationPlatform } from '~/protos/agents'

interface IntegrationPlatformItemOptions {
  includeMuleSoft?: boolean
  includeNodeJs?: boolean
  includeSapPiPo?: boolean
}

function formatIntegrationPlatformLabel(label: string) {
  const abbrs = ['IBM', 'TIBCO']
  let formattedLabel = label
    .toLowerCase()
    .replace(/_/g, ' ')
    .replace(/\b\w/g, char => char.toUpperCase())

  for (const abbr of abbrs) {
    const regex = new RegExp(`\\b${abbr}\\b`, 'gi')
    formattedLabel = formattedLabel.replace(regex, abbr)
  }
  return formattedLabel
}

function getIntegrationPlatformItem(platformKey: string) {
  if (platformKey === 'TIBCO') {
    return {
      label: formatIntegrationPlatformLabel('TIBCO_5'),
      key: 'TIBCO'
    }
  }
  return {
    label: formatIntegrationPlatformLabel(platformKey),
    key: platformKey
  }
}

export function getIntegrationPlatformItems(
  exclude?: string[],
  options: IntegrationPlatformItemOptions = {}
) {
  return Object.keys(IntegrationPlatform)
    .filter(
      ex =>
        ex !== 'UNRECOGNIZED' &&
        ex !== 'UNKNOW_INTEGRATION_PLATFORM' &&
        (options.includeMuleSoft || ex !== 'MULESOFT') &&
        (options.includeNodeJs || ex !== 'NODE_JS') &&
        (options.includeSapPiPo || ex !== 'SAP_PI_PO') &&
        Number.isNaN(Number(ex)) &&
        !exclude?.includes(ex)
    )
    .map(getIntegrationPlatformItem)
}

export function getIntegrationPlatformItemsForKeys(platformKeys: string[]) {
  return [...new Set(platformKeys)].map(getIntegrationPlatformItem)
}
